import styled from 'styled-components';

export const LiveModeMarker = styled.div`
  height: 8px;
  width: 8px;
  border-radius: 50%;
  display: inline-block;
  background-color: red;
  margin-right: 5px;
`;
